import React, { useEffect, useState, createElement } from 'react';
import { Header } from '../components/heylloyd/Header';
import { StepSection } from '../components/heylloyd/StepSection';
import { LloydCard } from '../components/heylloyd/LloydCard';
import { DecisionGuide } from '../components/heylloyd/DecisionGuide';
import { SundayCountdownTimer } from '../components/SundayCountdownTimer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { ShoppingCart, Monitor, Bot, Check, X, Zap, Clock, Rocket, ChevronDown, Users, Video, Calendar } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function WebinarReplyPageIndia() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  useEffect(() => {
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/bs7ghearnt.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Add Wistia player styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='bs7ghearnt']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/bs7ghearnt/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
    };
  }, []);
  const faqs = [{
    question: '48/hrs AI Cash Machine में वास्तव में क्या शामिल है?',
    answer: 'आपको सभी विशेष Custom Lloyds और पूर्ण चरण-दर-चरण सिस्टम तक तत्काल पहुंच मिलती है। इसके अलावा, आपको विस्तृत गाइड, Facebook के निजी समूह तक पहुंच, और Gabriel Beltran के साथ मासिक लाइव कॉल मिलेंगे। नोट: HeyLloyd एक अलग मासिक सॉफ्टवेयर है ($20/माह वार्षिक योजना या $40/माह मासिक योजना) जो Custom Lloyds का उपयोग करने के लिए आवश्यक है।'
  }, {
    question: 'क्या मैं बिना अनुभव के 48 घंटे में वास्तव में एक उत्पाद बना सकता हूं?',
    answer: 'हां। Custom Lloyds आपको प्रत्येक कार्य में चरण-दर-चरण मार्गदर्शन करते हैं। आपको तकनीकी, डिज़ाइन या मार्केटिंग ज्ञान की आवश्यकता नहीं है। सिस्टम आपको हर पल बताता है कि क्या करना है, सीखने की अवधि को समाप्त करता है।'
  }, {
    question: 'Facebook का निजी समूह क्या है?',
    answer: 'यह 48/hrs AI Cash Machine के सदस्यों के लिए एक विशेष समुदाय है जहां आप अन्य उद्यमियों से जुड़ सकते हैं, अनुभव साझा कर सकते हैं, प्रश्न पूछ सकते हैं और अपनी निर्माण और लॉन्च प्रक्रिया में निरंतर समर्थन प्राप्त कर सकते हैं।'
  }, {
    question: 'Gabriel Beltran के साथ मासिक कॉल कैसे काम करते हैं?',
    answer: 'हर महीने, एक सोमवार को, Gabriel Beltran सदस्यों के लिए एक विशेष लाइव कॉल करते हैं जहां वे प्रश्नों के उत्तर देते हैं, अपडेटेड रणनीतियां साझा करते हैं और आपके व्यवसाय को बढ़ाने में मदद करते हैं। ये सत्र रिकॉर्ड किए जाते हैं यदि आप लाइव में शामिल नहीं हो सकते।'
  }, {
    question: 'यदि मैं 48 घंटे में सब कुछ पूरा नहीं करता तो क्या होगा?',
    answer: 'कोई समस्या नहीं। 48 घंटे चरण-दर-चरण सिस्टम का पालन करते हुए अनुमानित समय है, लेकिन आपके पास सभी Custom Lloyds और संसाधनों तक आजीवन पहुंच है। आप अपनी गति से आगे बढ़ सकते हैं।'
  }, {
    question: 'क्या मुझे HeyLloyd के लिए अलग से भुगतान करना होगा?',
    answer: 'हां, HeyLloyd एक मासिक सॉफ्टवेयर है जिसका भुगतान अलग से किया जाता है। यदि आप वार्षिक भुगतान करते हैं तो यह $20/माह या मासिक भुगतान करते हैं तो $40/माह है। HeyLloyd वह प्लेटफॉर्म है जो आपके कंप्यूटर पर Custom Lloyds चलाता है। विशेष Custom Lloyds 48/hrs AI Cash Machine में शामिल हैं।'
  }, {
    question: 'क्या यह Mac और Windows पर काम करता है?',
    answer: 'हां, HeyLloyd Mac और Windows दोनों पर काम करता है। सिस्टम आपके कंप्यूटर के अनुकूल होता है और दोनों प्लेटफार्मों पर समान रूप से काम करता है।'
  }, {
    question: 'क्या रिफंड की गारंटी है?',
    answer: 'हां, हम 30 दिन की संतुष्टि गारंटी प्रदान करते हैं। यदि आप उत्पाद से संतुष्ट नहीं हैं, तो आप पहले 30 दिनों के भीतर पूर्ण रिफंड का अनुरोध कर सकते हैं।'
  }];
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-5056">
      <Header data-id="element-5057" />

      {/* Hero Section */}
      <section className="pt-14 md:pt-16 py-6 md:py-10 bg-gradient-to-b from-gray-900 to-black" data-id="element-5058">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-5059">
          <div className="text-center mb-5" data-id="element-5060"></div>

          <h1 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-3 md:mb-5 leading-tight text-center tracking-tight" data-id="element-5061">
            48/hrs AI Cash Machine
          </h1>

          <p className="text-base md:text-lg text-gray-100 mb-5 md:mb-7 max-w-3xl mx-auto leading-relaxed text-center" data-id="element-5062">
            पूर्ण सिस्टम जो आपको 48 घंटे से कम समय में AI के साथ अपना डिजिटल
            उत्पाद बनाने और लॉन्च करने में चरण-दर-चरण मार्गदर्शन करता है
          </p>

          {/* Video Player */}
          <div className="mb-8 md:mb-10" data-id="element-5063">
            <div className="w-full max-w-4xl mx-auto overflow-hidden border border-cyan-500" style={{
            boxShadow: '0 0 40px rgba(6, 182, 212, 0.4), 0 0 80px rgba(6, 182, 212, 0.2)'
          }} data-id="element-5064">
              <wistia-player media-id="bs7ghearnt" aspect="1.7777777777777777" data-id="element-5065"></wistia-player>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-5066">
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-5067">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-2xl text-lg md:text-xl py-5 md:py-6 px-8 md:px-12" leftIcon={<ShoppingCart className="w-6 h-6" data-id="element-5069" />} data-id="element-5068">
                अभी खरीदें - तत्काल पहुंच
              </Button>
            </a>
          </div>

          {/* Countdown Timer */}
          <div className="max-w-2xl mx-auto" data-id="element-5070">
            <SundayCountdownTimer data-id="element-5071" />
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="py-10 md:py-14 bg-black" data-id="element-5072">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-5073">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl shadow-2xl p-5 md:p-8 border border-gray-700" data-id="element-5074">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-5075">
              <Zap className="w-7 h-7 md:w-9 md:h-9 text-yellow-500" data-id="element-5076" />
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-5077">
                भले ही आपके पास अनुभव न हो
              </h3>
            </div>
            <p className="text-base md:text-lg text-gray-100 text-center leading-relaxed" data-id="element-5078">
              विशेष Custom Lloyds के साथ चरण-दर-चरण सिस्टम आपको प्रक्रिया के
              प्रत्येक चरण में मार्गदर्शन करेगा ताकि आप 48 घंटे या उससे कम समय
              में लाइव हो सकें
            </p>
          </div>
        </div>
      </section>

      {/* PASO 1 */}
      <div id="paso-1" data-id="element-5079">
        <StepSection stepNumber="1" title="सभी Custom Lloyds तक तत्काल पहुंच प्राप्त करें" data-id="element-5080">
          <p className="text-lg md:text-xl text-gray-400 mb-6 md:mb-8" data-id="element-5081">
            48/hrs AI Cash Machine खरीदने पर, आपको सभी विशेष Custom Lloyds और
            पूर्ण चरण-दर-चरण सिस्टम तक तत्काल पहुंच मिलेगी जो आपको प्रत्येक चरण
            में मार्गदर्शन करेगा।
          </p>

          <div className="mb-8 md:mb-10" data-id="element-5082">
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-5083">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-lg hover:shadow-xl" leftIcon={<ShoppingCart className="w-5 h-5" data-id="element-5085" />} data-id="element-5084">
                अभी खरीदें - तत्काल पहुंच
              </Button>
            </a>
          </div>

          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-xl p-6 md:p-8 border border-cyan-700 mb-6" data-id="element-5086">
            <h4 className="font-bold text-white mb-4 text-lg flex items-center gap-2" data-id="element-5087">
              <Rocket className="w-6 h-6 text-cyan-400" data-id="element-5088" />
              आपको तुरंत क्या मिलता है:
            </h4>
            <div className="space-y-3" data-id="element-5089">
              {['सभी विशेष Custom Lloyds तक तत्काल पहुंच', 'अपना उत्पाद बनाने के लिए पूर्ण चरण-दर-चरण सिस्टम', 'प्रक्रिया के प्रत्येक चरण के लिए विस्तृत गाइड', 'Facebook के निजी समूह तक पहुंच', 'Gabriel Beltran के साथ मासिक लाइव कॉल', 'कार्यान्वयन के लिए प्राथमिकता समर्थन'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-5090">
                  <Check className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-5091" />
                  <span className="text-gray-200" data-id="element-5092">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="bg-cyan-900/70 border border-cyan-500 rounded-xl p-4 md:p-6" data-id="element-5093">
            <p className="text-white text-sm md:text-base" data-id="element-5094">
              <strong className="text-cyan-100" data-id="element-5095">महत्वपूर्ण नोट:</strong> Custom
              Lloyds का उपयोग करने के लिए, आपको HeyLloyd की आवश्यकता होगी, एक
              मासिक सॉफ्टवेयर जिसका भुगतान अलग से किया जाता है ($20/माह वार्षिक
              योजना या $40/माह मासिक योजना)। HeyLloyd वह प्लेटफॉर्म है जो आपके
              कंप्यूटर पर Custom Lloyds चलाता है।
            </p>
          </div>
        </StepSection>
      </div>

      {/* PASO 2 */}
      <div id="paso-2" data-id="element-5096">
        <StepSection stepNumber="2" title="Custom Lloyds चलाने के लिए HeyLloyd का उपयोग करें" bgColor="gray" data-id="element-5097">
          <p className="text-lg md:text-xl text-slate-800 mb-4 md:mb-6" data-id="element-5098">
            HeyLloyd वह सॉफ्टवेयर है जो Custom Lloyds चलाता है। यह एक पारदर्शी
            डेस्कटॉप ओवरले है जो आपकी स्क्रीन पर रखा जाता है और आपको वास्तविक
            समय में मार्गदर्शन करता है:
          </p>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-5099">
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-5100">
              <Monitor className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-5101" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-5102">
                हमेशा की तरह काम करें
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-5103">
                आप अपना सामान्य कंप्यूटर देखते हैं, लेकिन अब Custom Lloyds आपको
                चरण-दर-चरण मार्गदर्शन कर रहे हैं।
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-5104">
              <Bot className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-5105" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-5106">
                वास्तविक समय सहायता
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-5107">
                Custom Lloyds वही देखते हैं जो आप देखते हैं और आपको प्रत्येक
                कार्य के लिए सटीक निर्देश देते हैं।
              </p>
            </div>
          </div>

          <div className="bg-cyan-900/70 border border-cyan-500 rounded-xl p-4 md:p-6 mb-6" data-id="element-5108">
            <h4 className="font-bold text-white mb-3 text-base md:text-lg flex items-center gap-2" data-id="element-5109">
              <Check className="w-5 h-5 text-cyan-300" data-id="element-5110" />
              HeyLloyd की कीमतें (मासिक सॉफ्टवेयर):
            </h4>
            <div className="space-y-2 text-white text-sm md:text-base" data-id="element-5111">
              <div className="flex items-center gap-2" data-id="element-5112">
                <Check className="w-4 h-4 text-cyan-300 flex-shrink-0" data-id="element-5113" />
                <span data-id="element-5114">
                  <strong className="text-cyan-100" data-id="element-5115">वार्षिक योजना:</strong>{' '}
                  $20/माह (वार्षिक बिल)
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-5116">
                <Check className="w-4 h-4 text-cyan-300 flex-shrink-0" data-id="element-5117" />
                <span data-id="element-5118">
                  <strong className="text-cyan-100" data-id="element-5119">मासिक योजना:</strong>{' '}
                  $40/माह (मासिक बिल)
                </span>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 md:p-6 rounded-r-lg" data-id="element-5120">
            <p className="font-bold text-slate-900 mb-2 flex items-center gap-2" data-id="element-5121">
              <Clock className="w-5 h-5 text-yellow-600" data-id="element-5122" />
              48 घंटे क्यों?
            </p>
            <p className="text-slate-700 text-sm md:text-base" data-id="element-5123">
              क्योंकि Custom Lloyds सीखने की अवधि को समाप्त करते हैं। आपको
              प्रौद्योगिकी, डिज़ाइन या मार्केटिंग के बारे में जानने की आवश्यकता
              नहीं है। सिस्टम आपको हर पल बताता है कि क्या करना है, जिससे आप 48
              घंटे में वह पूरा कर सकते हैं जो सामान्य रूप से हफ्तों या महीनों
              में होता।
            </p>
          </div>
        </StepSection>
      </div>

      {/* PASO 3 */}
      <div id="paso-3" data-id="element-5124">
        <StepSection stepNumber="3" title="विशेष Custom Lloyds का उपयोग करें" data-id="element-5125">
          <p className="text-slate-800 mb-4 md:mb-6 text-sm md:text-base" data-id="element-5126">
            प्रत्येक <strong data-id="element-5127">Custom Lloyd</strong> एक विशेष बॉट है जो आपको
            प्रक्रिया के एक विशिष्ट कार्य में मार्गदर्शन करता है। अपना उत्पाद
            बनाने से लेकर बिक्री कॉपी लिखने तक, प्रत्येक Lloyd आपका हाथ पकड़ने
            के लिए पूर्व-कॉन्फ़िगर किया गया है।
          </p>
          <div className="bg-slate-50 rounded-xl p-4 md:p-6 border border-slate-200 mb-6 md:mb-8" data-id="element-5128">
            <h4 className="font-bold text-slate-900 mb-3 md:mb-4 text-sm md:text-base" data-id="element-5129">
              सिस्टम कैसे काम करता है:
            </h4>
            <ol className="list-decimal list-inside space-y-2 text-slate-800 text-sm md:text-base" data-id="element-5130">
              <li data-id="element-5131">आप अपने वर्तमान कार्य के लिए आवश्यक Lloyd का चयन करते हैं</li>
              <li data-id="element-5132">HeyLloyd उस विशेष बॉट को लोड करता है</li>
              <li data-id="element-5133">
                आप अपनी स्क्रीन पर दिखाई देने वाले चरण-दर-चरण निर्देशों का पालन
                करते हैं
              </li>
              <li data-id="element-5134">आप कार्य पूरा करते हैं और अगले Lloyd पर जाते हैं</li>
            </ol>
          </div>
          <div className="space-y-2" data-id="element-5135">
            <h4 className="font-bold text-slate-900 text-sm md:text-base" data-id="element-5136">
              सब कुछ इस तरह डिज़ाइन किया गया है कि:
            </h4>
            <ul className="space-y-2 text-slate-800 text-sm md:text-base" data-id="element-5137">
              <li className="flex items-center" data-id="element-5138">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-5139" />
                आपको पूर्व तकनीकी ज्ञान की आवश्यकता नहीं है
              </li>
              <li className="flex items-center" data-id="element-5140">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-5141" />
                आपको यह सोचने की आवश्यकता नहीं है कि आगे क्या करना है
              </li>
              <li className="flex items-center" data-id="element-5142">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-5143" />
                आप 48 घंटे या उससे कम में पूरी प्रक्रिया पूरी कर सकते हैं
              </li>
            </ul>
          </div>
        </StepSection>
      </div>

      {/* GALLERY */}
      <section id="gallery" className="py-12 md:py-20 bg-slate-50 border-t border-slate-200" data-id="element-5144">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-5145">
          <div className="text-center mb-10 md:mb-16" data-id="element-5146">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3 md:mb-4 px-2" data-id="element-5147">
              48/hrs AI Cash Machine में शामिल Custom Lloyds
            </h2>
            <p className="text-slate-800 max-w-2xl mx-auto text-sm md:text-base px-2" data-id="element-5148">
              ये सभी विशेष Custom Lloyds शामिल हैं और प्रक्रिया के प्रत्येक चरण
              में आपका मार्गदर्शन करने के लिए तैयार हैं
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-5149">
            <LloydCard title="AI Product Builder" subtitle="AI के साथ उत्पाद निर्माण" description="शुरुआत से डिजिटल उत्पाद बनाने के लिए आपका पूर्ण सहायक। HeyLloyd आपको हर कदम पर मार्गदर्शन करता है: प्रारंभिक विचार से लेकर लॉन्च तक, बिना तकनीकी अनुभव के पेशेवर उत्पाद बनाने में मदद करता है।" imageSrc="https://cdn.magicpatterns.com/uploads/pXDmn28qLnCMrUYkdpGPpS/hf_20260116_225721_4dc7f3c1-48e8-4206-b7a5-3ddf70d36f02.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5150" />
            <LloydCard title="Ebook Writer" subtitle="ईबुक लेखन" description="शुरुआत से पूर्ण ईबुक बनाने के लिए बिल्कुल सही। HeyLloyd आपको संरचना, अध्याय और सामग्री में मार्गदर्शन करेगा ताकि आप अपनी ईबुक चरण-दर-चरण लिख सकें, सीधे अपनी स्क्रीन पर।" imageSrc="https://cdn.magicpatterns.com/uploads/mZHQRarDkUFPHSnnRgrYNx/heylloyd-image-1768596398723.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5151" />
            <LloydCard title="Ebook Cover Designer" subtitle="कवर डिज़ाइन" description="अपनी ईबुक के लिए पेशेवर और आकर्षक कवर बनाने में विशेषज्ञ। HeyLloyd आपको दृश्य डिज़ाइन, टाइपोग्राफी और ग्राफिक तत्वों में मार्गदर्शन करता है ताकि आपकी ईबुक अलग दिखे और पाठकों को आकर्षित करे।" imageSrc="https://cdn.magicpatterns.com/uploads/95YcbtScePy8FYnqxtUWrb/hf_20260116_225742_c84c2966-04d0-407a-8eb3-53f8e6f29bab.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5152" />
            <LloydCard title="Identity Persuasion Copywriter" subtitle="प्रेरक कॉपी" description="आपके दर्शकों की पहचान से जुड़ने वाली कॉपी बनाने में विशेषज्ञ। उन्नत कॉपीराइटिंग तकनीकों के साथ संदेश लिखने के लिए आदर्श जो प्रेरित करते हैं, बेचते हैं और रूपांतरण उत्पन्न करते हैं।" imageSrc="https://cdn.magicpatterns.com/uploads/mSU1vsY4XXAQMJDxHLq9tK/heylloyd-image-1768596505790.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5153" />
            <LloydCard title="Sales Letter Weapon" subtitle="बिक्री पत्र" description="रूपांतरित करने वाले बिक्री पत्र बनाने के लिए आपका गुप्त हथियार। HeyLloyd आपको प्रेरक बिक्री पत्र संरचित और लिखने में मदद करेगा जो वास्तविक परिणाम उत्पन्न करते हैं।" imageSrc="https://cdn.magicpatterns.com/uploads/5Vbgxv8pJwQBoVv72Jwat3/heylloyd-image-1768596561791.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5154" />
            <LloydCard title="Meta Ads Decision Engine" subtitle="विज्ञापन अनुकूलन" description="आपके Meta Ads अभियानों के लिए निर्णय इंजन। HeyLloyd आपको वास्तविक समय में अपने Facebook और Instagram विज्ञापनों का विश्लेषण, अनुकूलन और रणनीतिक निर्णय लेने में मदद करता है।" imageSrc="https://cdn.magicpatterns.com/uploads/uX7GKZjLzcZHYruWJanCH7/heylloyd-image-1768596648758.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5155" />
            <LloydCard title="The Viral PDF Lab" subtitle="वायरल PDF" description="बड़े पैमाने पर साझा किए जाने वाले PDF बनाने में विशेष प्रयोगशाला। लीड मैग्नेट, डाउनलोड करने योग्य संसाधनों और सामग्री के लिए आदर्श जिसे आपके दर्शक बार-बार साझा करना चाहेंगे।" imageSrc="https://cdn.magicpatterns.com/uploads/wRK7DAN3h4pP5mk1SskSzS/heylloyd-image-1768596692126.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5156" />
            <LloydCard title="AI Complete Brand Operation System" subtitle="पूर्ण ब्रांड सिस्टम" description="AI के साथ आपके ब्रांड के लिए पूर्ण परिचालन प्रणाली। रणनीति से लेकर निष्पादन तक, HeyLloyd आपको एकीकृत तरीके से अपने ब्रांड के निर्माण और संचालन के सभी पहलुओं में मार्गदर्शन करता है।" imageSrc="https://cdn.magicpatterns.com/uploads/i1MwR9sTfLGqX1o8cqMy9E/heylloyd-image-1768596733993.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="अभी पहुंच प्राप्त करें" buttonIcon="download" badge="शामिल" data-id="element-5157" />
          </div>
          <div className="text-center bg-gradient-to-r from-cyan-50 to-blue-50 p-6 md:p-8 rounded-xl border-2 border-cyan-200 max-w-3xl mx-auto shadow-lg" data-id="element-5158">
            <h4 className="font-bold text-slate-900 mb-3 text-xl flex items-center justify-center gap-2" data-id="element-5159">
              <Zap className="w-6 h-6 text-yellow-500" data-id="element-5160" />
              48/hrs AI Cash Machine में सभी Custom Lloyds शामिल हैं
            </h4>
            <p className="text-slate-800 mb-4" data-id="element-5161">
              आपको इन सभी विशेष Custom Lloyds और पूर्ण चरण-दर-चरण सिस्टम तक
              तत्काल पहुंच मिलती है। Custom Lloyds HeyLloyd में चलते हैं (अलग
              मासिक सॉफ्टवेयर: $20/माह वार्षिक या $40/माह मासिक)।
            </p>
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-5162">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-xl" leftIcon={<ShoppingCart className="w-5 h-5" data-id="element-5164" />} data-id="element-5163">
                सभी Custom Lloyds तक पहुंच प्राप्त करें
              </Button>
            </a>
          </div>
        </div>
      </section>

      <DecisionGuide data-id="element-5165" />

      {/* FAQ Section */}
      <section className="py-12 md:py-20 bg-white" data-id="element-5166">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-5167">
          <div className="text-center mb-10 md:mb-16" data-id="element-5168">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-5169">
              अक्सर पूछे जाने वाले प्रश्न
            </h2>
            <p className="text-lg text-slate-800" data-id="element-5170">
              48/hrs AI Cash Machine के बारे में सबसे आम प्रश्नों के उत्तर खोजें
            </p>
          </div>

          {/* Community & Support Highlight */}
          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-5171">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-200" data-id="element-5172">
              <div className="flex items-center gap-3 mb-3" data-id="element-5173">
                <div className="bg-blue-500 rounded-full p-2" data-id="element-5174">
                  <Users className="w-6 h-6 text-white" data-id="element-5175" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg" data-id="element-5176">
                  Facebook का निजी समूह
                </h3>
              </div>
              <p className="text-slate-700 text-sm" data-id="element-5177">
                हमारे निजी समुदाय तक विशेष पहुंच जहां आप अन्य सदस्यों से जुड़
                सकते हैं, अनुभव साझा कर सकते हैं और निरंतर समर्थन प्राप्त कर
                सकते हैं।
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-200" data-id="element-5178">
              <div className="flex items-center gap-3 mb-3" data-id="element-5179">
                <div className="bg-purple-500 rounded-full p-2" data-id="element-5180">
                  <Video className="w-6 h-6 text-white" data-id="element-5181" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg" data-id="element-5182">
                  मासिक लाइव कॉल
                </h3>
              </div>
              <p className="text-slate-700 text-sm" data-id="element-5183">
                हर महीने, एक सोमवार को, Gabriel Beltran आपके व्यवसाय को बढ़ाने
                और आपके प्रश्नों के उत्तर देने में मदद करने के लिए एक लाइव सत्र
                आयोजित करते हैं।
              </p>
            </div>
          </div>

          <div className="space-y-4" data-id="element-5184">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-md border border-slate-200 overflow-hidden transition-all duration-300 hover:shadow-lg" data-id="element-5185">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 transition-colors duration-200 hover:bg-slate-50" data-id="element-5186">
                  <span className="text-lg font-semibold text-slate-900 pr-4" data-id="element-5187">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-cyan-600 flex-shrink-0 transition-transform duration-300 ${openFaqIndex === index ? 'rotate-180' : ''}`} data-id="element-5188" />
                </button>
                <div className={`transition-all duration-300 ease-in-out ${openFaqIndex === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`} data-id="element-5189">
                  <div className="px-6 pb-5 pt-2" data-id="element-5190">
                    <p className="text-slate-700 leading-relaxed" data-id="element-5191">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-gradient-to-r from-cyan-50 to-blue-50 p-6 rounded-xl border border-cyan-200" data-id="element-5192">
            <p className="text-slate-800 mb-4" data-id="element-5193">
              और प्रश्न हैं? सीधे हमसे संपर्क करें:
            </p>
            <a href="mailto:support@truemarketer.com" className="text-cyan-600 hover:text-cyan-700 font-semibold underline" data-id="element-5194">
              support@truemarketer.com
            </a>
          </div>
        </div>
      </section>

      {/* Book a Call Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-white to-slate-50" data-id="element-5195">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-5196">
          <div className="bg-gradient-to-r from-cyan-500 to-blue-500 rounded-xl p-8 md:p-12 text-center shadow-2xl" data-id="element-5197">
            <Calendar className="w-12 h-12 md:w-16 md:h-16 text-white mx-auto mb-6" data-id="element-5198" />
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-4" data-id="element-5199">
              शुरू करने में मदद चाहिए?
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-5200">
              AI के साथ अपना डिजिटल उत्पाद कैसे बनाएं, इस पर चर्चा करने के लिए
              हमारी टीम के साथ एक मुफ्त स्पष्टता कॉल बुक करें
            </p>
            <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-cyan-600 px-8 md:px-12 py-4 md:py-5 rounded-full font-bold text-lg md:text-xl hover:bg-gray-50 hover:scale-105 transition-all duration-300 shadow-xl" data-id="element-5201">
              स्पष्टता कॉल बुक करें
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-white to-cyan-50" data-id="element-5202">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-5203">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-6" data-id="element-5204">
            आज ही अपना 48/hrs AI Cash Machine शुरू करें
          </h2>
          <p className="text-xl text-slate-800 mb-8 max-w-2xl mx-auto" data-id="element-5205">
            HeyLloyd और सभी Custom Lloyds तक तत्काल पहुंच। अभी अपना डिजिटल
            उत्पाद बनाना शुरू करें।
          </p>
          <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-5206">
            <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-2xl text-xl py-6 px-12" leftIcon={<ShoppingCart className="w-6 h-6" data-id="element-5208" />} data-id="element-5207">
              अभी खरीदें - तत्काल पहुंच
            </Button>
          </a>
          <p className="text-sm text-slate-500 mt-4" data-id="element-5209">
            30 दिन की संतुष्टि गारंटी
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-slate-900 border-t border-slate-800" data-id="element-5210">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-5211">
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-5212">
            <p data-id="element-5213">
              48 HRS AI CASH MACHINE और संबंधित टीम आपके द्वारा प्राप्त
              परिणामों, आय या सफलता के लिए कोई जिम्मेदारी नहीं लेती है, और न ही
              विशिष्ट परिणामों की गारंटी देती है। सफलता आंशिक रूप से आपके द्वारा
              समर्पित समय और प्रदान किए गए गाइड, रणनीतियों और समर्थन के आपके
              कार्यान्वयन पर निर्भर करती है।
            </p>
          </div>

          <div className="text-center mt-4 pt-3 border-t border-gray-700" data-id="element-5214">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-5215">
              &copy; 2025 48 Hrs AI Cash Machine. सर्वाधिकार सुरक्षित।
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-5216">
              समर्थन:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06B6D4] hover:text-[#0891b2] transition-colors" data-id="element-5217">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-5218">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-5219">
                नियम
              </button>
              <span className="text-gray-400" data-id="element-5220">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-5221">
                गोपनीयता
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-5222">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-5223">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-5224">
              <X className="w-6 h-6" data-id="element-5225" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-5226">
              नियम और शर्तें
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-5227">
              <p data-id="element-5228">
                48/hrs AI Cash Machine खरीदकर, आप निम्नलिखित नियमों और शर्तों को
                स्वीकार करते हैं।
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5229">
                1. नियमों की स्वीकृति
              </h3>
              <p data-id="element-5230">
                इस उत्पाद तक पहुंचने और उपयोग करने से, आप इन नियमों और शर्तों,
                सभी लागू कानूनों और विनियमों के अधीन होने के लिए सहमत होते हैं।
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5231">
                2. सेवा का उपयोग
              </h3>
              <p data-id="element-5232">
                प्रदान की गई सामग्री केवल शैक्षिक और सूचनात्मक उद्देश्यों के लिए
                है। हम आय या व्यावसायिक सफलता के विशिष्ट परिणामों की गारंटी नहीं
                देते हैं।
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5233">संपर्क</h3>
              <p data-id="element-5234">
                इन नियमों के बारे में प्रश्नों के लिए, संपर्क करें:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-5235">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-5236">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-5237">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-5238">
              <X className="w-6 h-6" data-id="element-5239" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-5240">
              गोपनीयता नीति
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-5241">
              <p data-id="element-5242">
                48 Hrs AI Cash Machine में, हम आपकी गोपनीयता की रक्षा के लिए
                प्रतिबद्ध हैं। यह नीति बताती है कि हम आपकी व्यक्तिगत जानकारी
                कैसे एकत्र, उपयोग और सुरक्षित करते हैं।
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5243">
                1. हम जो जानकारी एकत्र करते हैं
              </h3>
              <p data-id="element-5244">
                हम वह जानकारी एकत्र करते हैं जो आप सीधे हमें प्रदान करते हैं,
                जिसमें खरीद जानकारी और संचार शामिल हैं।
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5245">
                2. जानकारी का उपयोग
              </h3>
              <p data-id="element-5246">
                हम आपकी जानकारी का उपयोग उत्पाद तक पहुंच और समर्थन प्रदान करने
                के लिए करते हैं।
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5247">संपर्क</h3>
              <p data-id="element-5248">
                इस गोपनीयता नीति के बारे में प्रश्नों के लिए, संपर्क करें:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-5249">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-5250" />
    </div>;
}